module.exports = __webpack_public_path__ + "pc-top-assets/img/logo.d2b92f53.png";